import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../common/temp/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-退出",
  "use": "icon-退出-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-退出\">\n<path d=\"M4.65238 6.19028C3.53657 7.65445 2.86914 9.51301 2.86914 11.5355C2.86914 16.2589 6.50926 20.088 10.9996 20.088C15.4899 20.088 19.13 16.2589 19.13 11.5355C19.13 9.51301 18.4626 7.65445 17.3468 6.19028M10.9996 1.91406V10.4665\" stroke=\"currentColor\" stroke-width=\"2.29565\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol